import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaInstagram, FaFacebookF, FaYoutube } from 'react-icons/fa';

const Contact = () => {
  return (
    <footer 
      style={{
        fontFamily: "'Poppins', sans-serif",
        background: 'linear-gradient(135deg, #74fc96 0%, #ffffff 50%, #f3a057 100%)',
        borderTop: '4px solid #ff9933',
        color: '#000000',
        padding: '30px 20px',
        position: 'relative',
        overflow: 'hidden',
        maxWidth: '100%',
        boxSizing: 'border-box'
      }}
    >
      <style>{`
        .brand-wrap {
          display: flex;
          flex-direction: column;
          line-height: 1;
          text-decoration: none;
          padding: 4px 0;
          cursor: pointer;
        }

        .big-p {
          font-size: 1.3em;
          font-weight: 900;
        }

        .brand-text {
          font-size: 20px;
          font-weight: 900;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          font-family: 'Poppins', 'Montserrat', sans-serif;
          display: flex;
          align-items: baseline;
        }

        .brand-accent {
          width: 18px;
          height: 3.5px;
          margin-top: 4px;
          border-radius: 999px;
          background: linear-gradient(90deg, #ff9933 0%, #000080 50%, #138808 100%);
          transition: width 0.4s ease;
        }

        .brand-wrap:hover .brand-accent {
          width: 40%;
        }

        .footer-link {
          color: #000 ;
          font-weight: 500;
          transition: color 0.3s ease, transform 0.2s ease;
          display: inline-block;
        }
        .footer-link:hover {
          color: #ff9100 !important;
          transform: translateX(3px);
        }

        .hover-icon {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .hover-icon:hover {
          transform: scale(1.15);
        }

        .social-link {
          color: #000000 !important;
          font-weight: 500;
          transition: color 0.3s ease;
        }
        .social-link:hover {
          color: #ffb004 !important;
        }
      `}</style>

      <div className="container-fluid px-0">
        <div className="row align-items-start g-3 g-lg-0 mx-0">
          
          {/* Column 1: Logo, Title & Bio */}
          <div className="col-12 col-sm-6 col-lg-3 pe-lg-4 mb-3 mb-lg-0">
            <div className="mb-3">
              <a className="brand-wrap" href="#home">
                <div className="brand-text">
                  <span style={{ color: '#ff9933' }}>
                    <span className="big-p">P</span>ARAG
                  </span>
                  &nbsp;
                  <span style={{ color: '#138808' }}>
                    <span className="big-p">P</span>ATIL
                  </span>
                </div>
                <span className="brand-accent"></span>
              </a>
              <div className="mt-1">
                <small style={{ fontSize: '0.78rem', letterSpacing: '1.5px', color: '#000080', fontWeight: '900' }}>
                  PROFESSIONAL ATHLETE
                </small>
              </div>
            </div>
            <p style={{ fontSize: '14px', lineHeight: '1.5', color: '#000000', fontWeight: '500' }} className="mb-0">
              Representing India in 100 m Run, Long Jump &amp; Triple Jump. Dedicated to excellence and bringing pride to the nation.
            </p>
          </div>

          {/* Vertical Divider 1 */}
          <div className="col-auto d-none d-lg-block p-0">
            <div style={{ width: '1px', backgroundColor: '#c5bcae', height: '140px' }}></div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="col-12 col-sm-6 col-lg-3 px-lg-4 mb-3 mb-lg-0">
            <h6 style={{ fontSize: '0.9rem', fontWeight: 800, letterSpacing: '1px', color: '#000080', marginBottom: '14px' }}>QUICK LINKS</h6>
            <div className="row g-0" style={{ fontSize: '0.88rem' }}>
              <div className="col-6">
                <ul className="list-unstyled mb-0">
                  <li className="mb-2"><a href="#home" className="text-decoration-none footer-link">Home</a></li>
                  <li className="mb-2"><a href="#about" className="text-decoration-none footer-link">About Me</a></li>
                  <li className="mb-2"><a href="#career" className="text-decoration-none footer-link">Career Journey</a></li>
                  <li className="mb-2"><a href="#achievements" className="text-decoration-none footer-link">Achievements</a></li>
                </ul>
              </div>
              <div className="col-6">
                <ul className="list-unstyled mb-0">
                  <li className="mb-2"><a href="#gallery" className="text-decoration-none footer-link">Gallery</a></li>
                  <li className="mb-2"><a href="#experience" className="text-decoration-none footer-link">Experience</a></li>
                  <li className="mb-2"><a href="#contact" className="text-decoration-none footer-link">Contact</a></li>
                </ul>
              </div>
            </div>
          </div>

          {/* Vertical Divider 2 */}
          <div className="col-auto d-none d-lg-block p-0">
            <div style={{ width: '1px', backgroundColor: '#c5bcae', height: '140px' }}></div>
          </div>

          {/* Column 3: Contact */}
          <div className="col-12 col-sm-6 col-lg-3 px-lg-4 mb-3 mb-lg-0">
            <h6 style={{ fontSize: '0.9rem', fontWeight: 800, letterSpacing: '1px', color: '#000080', marginBottom: '14px' }}>CONTACT</h6>
            <div style={{ fontSize: '0.88rem', color: '#000000', fontWeight: '500' }}>
              <div className="d-flex align-items-start mb-2">
                <div className="hover-icon" style={{ backgroundColor: '#e65c00', color: '#fff', borderRadius: '4px', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', flexShrink: 0, marginRight: '10px', marginTop: '2px', cursor: 'pointer' }}>
                  <FaMapMarkerAlt />
                </div>
                <span>Chinchwad, Pune, Maharashtra, India</span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <div className="hover-icon" style={{ backgroundColor: '#000080', color: '#fff', borderRadius: '4px', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', flexShrink: 0, marginRight: '10px', cursor: 'pointer' }}>
                  <FaPhoneAlt />
                </div>
                <span>+91 98220 12345</span>
              </div>
              <div className="d-flex align-items-center">
                <div className="hover-icon" style={{ backgroundColor: '#008000', color: '#fff', borderRadius: '4px', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', flexShrink: 0, marginRight: '10px', cursor: 'pointer' }}>
                  <FaEnvelope />
                </div>
                <span>paragpatil.athlete@gmail.com</span>
              </div>
            </div>
          </div>

          {/* Vertical Divider 3 */}
          <div className="col-auto d-none d-lg-block p-0">
            <div style={{ width: '1px', backgroundColor: '#c5bcae', height: '140px' }}></div>
          </div>

          {/* Column 4: Follow Me & Signature */}
          <div className="col-12 col-sm-6 col-lg-2 ps-lg-4 d-flex flex-wrap justify-content-between align-items-start gap-2">
            <div>
              <h6 style={{ fontSize: '0.9rem', fontWeight: 800, letterSpacing: '1px', color: '#000080', marginBottom: '14px' }}>FOLLOW ME</h6>
              <div style={{ fontSize: '0.85rem' }}>
                <a href="#insta" className="d-flex align-items-center mb-2 text-decoration-none social-link">
                  <FaInstagram className="hover-icon" style={{ color: '#e1306c', fontSize: '20px', marginRight: '8px' }} />
                  <span>paragpatil_athlete</span>
                </a>
                <a href="#facebook" className="d-flex align-items-center mb-2 text-decoration-none social-link">
                  <FaFacebookF className="hover-icon" style={{ color: '#1877f2', fontSize: '20px', marginRight: '8px' }} />
                  <span>paragpatil.athlete</span>
                </a>
                <a href="#youtube" className="d-flex align-items-center text-decoration-none social-link">
                  <FaYoutube className="hover-icon" style={{ color: '#ff0000', fontSize: '20px', marginRight: '8px' }} />
                  <span>paragpatil_athlete</span>
                </a>
              </div>
            </div>

            <div className="text-start text-sm-end align-self-center mt-2 mt-sm-0">
              <span style={{ fontFamily: "cursive", fontSize: '20px', color: '#000080', fontWeight: 700, whiteSpace: 'nowrap' }}>
                Parag Patil
              </span>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Contact;
